<div class="email-template-editor h-full flex flex-col">
	<editor
		class="flex-grow min-h-0"
		[init]="tinyMCEInit"
		[(ngModel)]="content"
		(onInit)="editorReady($event)"
		[disabled]="disabled"
		[ngStyle]="{ minHeight: '600px' }"
	>
	</editor>
</div>
